import { createContext } from "react"

const CertHistoryContext = createContext({})

export default CertHistoryContext
